import { gql } from '@apollo/client';

export const GET_SAVED_SEARCHES = gql`
  query getSavedSearches {
    getSavedSearches {
      search
      totalFlyers
      totalNewFlyers
    }
  }
`;
